// extracted by mini-css-extract-plugin
export default {"myTabs":"tabs_myTabs__quKH4","badge":"tabs_badge__l0BAt","badge-yellow":"tabs_badge-yellow__Sg5A3","badge-green":"tabs_badge-green__WXirx","badge-red":"tabs_badge-red__nWSSZ"};